import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './informedArchives.module.scss';
import  { ApiCore } from '../../../api/index';
import patient_home_avatar from '../../../static/images_doctor/patient_home_avatar.png';
import patient_home_avatar_bg from '../../../static/images_doctor/patient_home_avatar_bg.png';
import followup_node_icon from '../../../static/images_doctor/followup_node_icon.png';
import right_arrow from '../../../static/images/rightArrow.png';
import utils from '../../../utils/utils';
import PatientHomeDetail from './patientHomeDetail';
import { PhotoSlider } from 'react-photo-view';

const api = new ApiCore();

function InformedArchives(props: any) {

    const [imgList, setImgList] = useState([]);
    const [photoVisible, setPhotoVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    //当前预览图片的index
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState<any>(0);

    useEffect(() => {
        initData();
        return () => {
        }
    }, [props.allData])

    const initData = () => {
        let _param = props.allData || {};
        if (Object.keys(_param).length > 0) {
            const params = new FormData();
            params.append('caseCode', _param.caseCode);
            params.append('patientCode', _param.patientCode);
            api.getPatientInformedConsent(params, {
                'Content-Type': 'application/x-www-form-urlencoded'
            }).then((res: any) => {
                if (res.code == 0) {
                    let _data = res.data || [];
                    let _imgItem = _data.filter((val: any) => val.type === 'image');
                    let _imgUrls = _imgItem[0]?.imgUrl;
                    let _imgList = [];
                    if (_imgUrls.indexOf(',') > 0) {
                        _imgList = _imgUrls.split(',');
                    } else {
                        _imgList = [_imgUrls];
                    }
                    setImgList(_imgList);
                }
            });
        }
    }

    const imgItemClick = (index: number) => {
        setCurrentPhotoIndex(index);
        setPhotoVisible(true);
        setShowModal(true);
    }

    const history = useHistory();

    return (
        <div className={`${styles.patientHome_informedArchives}`}>
            <div className={styles.gap}>

            </div>
            <div className={styles.head_title}>
                知情同意书
            </div>
            <div className={styles.img_count}>
                共{imgList.length}张知情同意图片
            </div>
             <div className={styles.img_wrap}>
                {
                    imgList && imgList.map((val: any, key: number)=> (
                        <div key={key} className={styles.img_text_container} onClick={() => { imgItemClick(key) }} >
                            <div className={styles.img_container} key={key}>
                                <img src={val} alt="" />
                                {/* <div className={styles.img_text}>照片{key + 1}</div> */}
                            </div>
                            <div className={styles.img_text}>照片{key + 1}</div>
                        </div>
                    ))
                }
             </div>
                {/* 图片预览 */}
                {
                    <PhotoSlider
                        photoClosable
                        bannerVisible={true}
                        images={imgList && imgList.map((item: any) => ({ src: item }))}
                        visible={photoVisible}
                        onClose={() => { setPhotoVisible(false);}}
                        index={currentPhotoIndex}
                        introVisible={true}
                        onIndexChange={(i: any) => { setCurrentPhotoIndex(i) }}
                    />
                }
        </div>
    )

}

export default InformedArchives;